import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { IoIosArrowForward } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { messageClear, place_order } from '../store/reducers/orderReducer'
import { submit_address, get_address } from '../store/reducers/homeReducer'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { backend_url_img } from '../api/server'
import { getCurrentTime } from '../utils/timeConvertor'

const fibLogo = '../../../images/payment/fib.png'

const codLogo = '../../../images/payment/cod.jpg'

const Shipping = () => {
  const {
    state: { products, price, shipping_fee, items },
  } = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const { userInfo } = useSelector((state) => state.auth)
  const { addresses } = useSelector((state) => state.home)
  const { errorMessage, successMessage } = useSelector((state) => state.order)

  // const { currencyIQD } = useSelector((state) => state.dashboard)
  
  const [res, setRes] = useState(false)
  const [state, setState] = useState({
    place: '',
    name: userInfo?.name || '',
    address: userInfo?.address || '',
    phone: userInfo?.phone || '',
    city: '',
    orderNote: '',
  })
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [newAddress, setNewAddress] = useState(null)
  // const [addressId, setAddressId] = useState(null)

  const [paymentMethod, setPaymentMethod] = useState('Cash on delivery')

  useEffect(() => {
    const savedRes = JSON.parse(localStorage.getItem('res'))
    const savedAddress = JSON.parse(localStorage.getItem('selectedAddress'))

    if (savedRes !== null) {
      setRes(savedRes)
    }

    if (savedAddress) {
      setSelectedAddress(savedAddress)
    } else {
      setSelectedAddress(null)
    }
  }, [])

  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    })
  }

  useEffect(() => {
    dispatch(get_address({ userId: userInfo?.id }))
  }, [dispatch])

  const handleSelectAddress = (event, address) => {
    setSelectedAddress(address)
    setRes(true)
    localStorage.setItem('selectedAddress', JSON.stringify(address))
    localStorage.setItem('res', JSON.stringify(true))
  }

  const save = (e) => {
    e.preventDefault()
    const newAddressData = {
      userId: userInfo.id,
      place: state.place,
      name: state.name,
      address: state.address,
      phone: state.phone,
      city: state.city,
    }

    dispatch(submit_address(newAddressData))
    setNewAddress(newAddressData)
    setRes(true)
    localStorage.setItem('selectedAddress', JSON.stringify(newAddressData))
    localStorage.setItem('res', JSON.stringify(true))
  }

  const handlePlaceOrder = async () => {
    const createdAt = getCurrentTime()

    dispatch(
      place_order({
        price,
        products,
        shipping_fee,
        items,
        shippingInfo: newAddress || selectedAddress,
        userId: userInfo.id,
        orderNote: state.orderNote,
        createdAt,
        paymentMethod: paymentMethod,
        // navigate,
      })
    )
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
      navigate('/')
    }
    if (errorMessage) {
      toast.error(errorMessage)
      dispatch(messageClear())
    }
  }, [successMessage, errorMessage])

  const getProductName = (product) => {
    switch (currentLanguage) {
      case 'ar':
        return product?.arName
      case 'kr':
        return product?.kuName
      default:
        return product?.enName
    }
  }

  return (
    <div>
      <Header />
      <section className=" mt-5 bg-cover bg-no-repeat relative bg-left">
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[65%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white"></div>
          </div>
        </div>
      </section>

      <section>
        <div className="bg-slate-100 py-5 mb-2">
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex justify-start items-center text-md text-slate-600 w-full">
              <Link to="/">{t('home.home')}</Link>
              <span className="pt-1">
                <IoIosArrowForward />
              </span>
              <span className="text-[#B65278]">{t('home.shipping')} </span>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white ">
        <div className="w-[69%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-8 sm:px-0">
          <div className="flex flex-wrap gap-3 ">
            <div className="w-[68%] md-lg:w-full border rounded-md p-2 ">
              <div className="px-2 md-lg:px-0">
                <div className="flex flex-col gap-3">
                  <div className=" w-full py-2">
                    <h2 className="text-slate-600 test-sm font-bold">
                      {t('home.shipping_information')}{' '}
                    </h2>
                  </div>
                  {!res && (
                    <>
                      <form onSubmit={save}>
                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="place"> {t('home.place')} </label>
                            <input
                              onChange={inputHandle}
                              value={state.place}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
                              name="place"
                              id="place"
                              placeholder={t('home.place')}
                              required
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="name"> {t('home.name')} </label>
                            <input
                              onChange={inputHandle}
                              value={state.name}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
                              name="name"
                              id="name"
                              placeholder={t('home.name')}
                              required
                            />
                          </div>
                        </div>
                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="address">
                              {' '}
                              {t('home.address')}{' '}
                            </label>
                            <input
                              onChange={inputHandle}
                              value={state.address}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
                              name="address"
                              id="address"
                              placeholder={t('home.address')}
                              required
                            />
                          </div>
                        </div>

                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="phone"> {t('home.phone')} </label>
                            <input
                              onChange={inputHandle}
                              value={state.phone}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
                              name="phone"
                              id="phone"
                              placeholder={t('home.phone')}
                              required
                            />
                          </div>

                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="city"> {t('home.city')} </label>
                            <input
                              onChange={inputHandle}
                              value={state.city}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
                              name="city"
                              id="city"
                              placeholder={t('home.city')}
                              required
                            />
                          </div>
                        </div>

                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mt-7 mb-2 w-1/3">
                            <button className="px-5 py-[9px] text-sm rounded-md hover:bg-[#4e658e]  bg-primary text-white">
                              {t('home.save')}{' '}
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  )}

                  {res && newAddress && (
                    <div className="flex flex-col gap-1">
                      <span className="text-slate-600 text-sm font-semibold pb-2">
                        {t('orderS.deliver_to')} {newAddress.place}
                      </span>
                      <p>
                        <span className="bg-blue-200 text-blue-800 text-sm font-medium mr-2 px-2 py-1 rounded">
                          {newAddress.place}
                        </span>
                        <span>
                          {newAddress.phone} {newAddress.address}{' '}
                          {newAddress.city}{' '}
                        </span>
                        <span
                          onClick={() => setRes(false)}
                          className="text-indigo-500 cursor-pointer"
                        >
                          {t('home.change')}{' '}
                        </span>
                      </p>
                    </div>
                  )}
                </div>
                {!res && addresses ? (
                  <div className="bg-white mt-3 mb-2 border-b">
                    <span className="text-slate-600 text-sm font-bold">
                      {' '}
                      {t('home.addresses')}{' '}
                    </span>
                  </div>
                ) : null}

                {!res &&
                  addresses &&
                  addresses.map((a, i) => (
                    <div key={i} className="flex bg-white p-2 flex-col gap-2">
                      <div className="flex justify-start items-center">
                        <div className="flex items-center gap-2">
                          <input
                            onChange={(e) => handleSelectAddress(e, a)}
                            checked={
                              selectedAddress?.place === a.place || false
                            }
                            className="w-5 h-5"
                            type="radio"
                            name="userType"
                            value="printHouse"
                            id={`printHouse-${i}`}
                            required
                          />
                          <label
                            htmlFor={`printHouse-${i}`}
                            className="text-md bg-primary px-2 py-1 rounded text-white"
                          >
                            {a.place}
                          </label>
                        </div>
                        <div className="flex items-center gap-2 px-3">
                          {a.address}
                        </div>
                        <div className="flex items-center gap-2 px-3">
                          {a.phone}
                        </div>
                        <div className="flex items-center gap-2 px-3">
                          {a.city}
                        </div>
                      </div>
                    </div>
                  ))}

                {res && selectedAddress && !newAddress && (
                  <div className="flex flex-col gap-1">
                    <h2 className="text-slate-600 text-sm font-semibold pb-2">
                      {t('orderS.deliver_to')} {selectedAddress.place}
                    </h2>
                    <p>
                      <span className="bg-blue-200 text-blue-800 text-sm font-medium mr-2 px-2 py-1 rounded">
                        {selectedAddress.place}
                      </span>
                      <span>
                        {selectedAddress.phone} {selectedAddress.address}{' '}
                        {selectedAddress.city}{' '}
                      </span>
                      <span
                        onClick={() => setRes(false)}
                        className="text-indigo-500 cursor-pointer"
                      >
                        {t('home.change')}{' '}
                      </span>
                    </p>
                  </div>
                )}

                <div className="flex flex-col gap-1 mt-6 mb-6 w-full">
                  <label
                    htmlFor="city"
                    className="text-slate-600 text-sm font-bold"
                  >
                    {' '}
                    {t('orderS.order_note')}{' '}
                  </label>
                  <textarea
                    onChange={inputHandle}
                    value={state.orderNote}
                    type="text"
                    className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
                    name="orderNote"
                    id="orderNote"
                    placeholder={t('orderS.order_note')}
                    required
                  />
                </div>
                <div className="bg-white  mt-6">
                  <h2 className="text-slate-600 text-sm font-bold">
                    {t('home.productList')}{' '}
                  </h2>
                </div>
                {products?.map((p, i) => (
                  <div
                    className="flex bg-white shadow-md border border-slate-50 p-4 flex-col gap-2"
                    key={p._id}
                  >
                    <div className="flex justify-start items-center gap-4 py-2">
                      <h2 className="text-sm text-slate-600 font-bold">
                        {getProductName(p.productInfo)}
                      </h2>
                      <div className="flex justify-center items-center ">
                        <span className="font-medium">
                          {t('products.product_code')}:{' '}
                          {p.productInfo.productCode}
                        </span>
                      </div>
                    </div>

                    <div className="w-full flex flex-wrap">
                      <div className="flex sm:w-full  items-center gap-2 w-8/12">
                        <div className="flex gap-2 justify-start items-center">
                          <img
                            className="w-[100px] h-auto"
                            src={`${backend_url_img}/${p?.productInfo.images[0]}`}
                            alt={p.productInfo.enName || 'Product Image'}
                          />
                          <div className="px-2  text-white">
                            {p.selectedPack ? (
                              <div
                                className="flex flex-col text-sm font-semibold w-full gap-2"
                                key={
                                  p.selectedPack._id || p.selectedPack.pack.code
                                }
                              >
                                {/* Pack Info */}
                                <div className="flex gap-2 items-center px-2 py-2 bg-darkRed justify-center border rounded-md ">
                                  <span className="font-base">
                                    {p.selectedPack.pack?.code} ×{' '}
                                    {getProductName(p.selectedPack.pack)}
                                  </span>
                                  <span className="text-sm font-normal text-white">
                                    ({p.selectedPack.price?.toFixed(2)}{' '}
                                    {t('products.currency')})
                                  </span>
                                </div>

                                {/* Properties */}
                                <div className="flex flex-col gap-1 px-1">
                                  {p.selectedPack.properties?.length > 0 ? (
                                    p.selectedPack.properties.map(
                                      (prop, propIndex) => (
                                        <div
                                          key={prop._id || propIndex}
                                          className="flex items-center gap-2"
                                        >
                                          <span className="font-light">
                                            {prop}
                                          </span>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <span className="text-sm font-light text-slate-400">
                                      {t('home.no_properties_available')}
                                    </span>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <span className="text-sm font-light text-slate-400">
                                {t('home.no_pack_selected')}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex item-center justify-center w-4/12 sm:w-full sm:mt-3">
                        <span className=" px-2 font-medium text-lg">
                          {t('products.price')}:
                        </span>
                        <div className="flex w-full sm:w-full justify-between">
                          <div className="">
                            <h2
                              className={`text-lg text-orange-500 ${
                                isRTL ? 'flex-row' : ''
                              }`}
                            >
                              {p.selectedPack
                                ? new Intl.NumberFormat('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(
                                    p.selectedPack.price *
                                      p.selectedPack.pack.code
                                  )
                                : ''}{' '}
                              {t('products.currency')}
                            </h2>
                            {/* </>
                                               )} */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`flex items-center justify-start sm:justify-center text-sm font-bold ${
                        isRTL ? 'rtl text-right' : 'ltr text-left'
                      } px-2 pt-2`}
                    >
                      <h2 className="px-2  whitespace-nowrap">
                        {t('home.total_price')} :
                      </h2>
                      <span className="whitespace-nowrap">
                        {(() => {
                          if (!p?.selectedPack) return null

                          const packCode =
                            Number(p.selectedPack.pack?.code) || 0
                          const quantity = Number(p.quantity) || 0
                          const packPrice = Number(p.selectedPack.price) || 0

                          const totalPrice = (
                            packCode *
                            quantity *
                            packPrice
                          ).toFixed(2)
                          const currency = t('products.currency')

                          return isRTL
                            ? ` ${quantity} × (${packCode} × ${packPrice.toFixed(
                                2
                              )})  = ${totalPrice} ${currency}`
                            : `${quantity} × (${packCode} × ${packPrice.toFixed(
                                2
                              )}) = ${totalPrice} ${currency}`
                        })()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-[31%] md-lg:w-full  border rounded-md ">
              <div className="px-3 md-lg:px-0 md-lg:mt-5">
                <div className="bg-white p-3 text-slate-600 flex flex-col gap-3">
                  <h2 className="text-md font-bold">
                    {t('orderS.order_summary')}
                  </h2>
                  <div className="flex justify-between items-center">
                    <span className="font-bold text-sm">
                      {t('orderS.order_total')}{' '}
                    </span>
                    <span className="flex text-md font-bold">
                      {new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format((price / 250) * 250)}{' '}
                      {t('products.currency')}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>{t('orderS.delivery_fee')} </span>
                    <span>
                      {new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format((shipping_fee / 250) * 250)}{' '}
                      {t('products.currency')}{' '}
                    </span>
                  </div>

                  <div className="flex justify-between items-center border-t py-2">
                    <span className="font-bold text-sm">
                      {' '}
                      {t('orderS.total_price')}
                    </span>
                    <span className="text-lg font-bold text-[#059473]">
                      {new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(((price + shipping_fee) / 250) * 250)}{' '}
                      {t('products.currency')}
                    </span>
                  </div>

                  {/* {ayment Methos} */}

                  <section className="bg-white">
                    <div className="w-full mx-auto pt-4  pb-8 mb-6 sm:px-0 bg-slate-300">
                      <div className="flex  md:flex-col-reverse gap-4 ">
                        <div className="w-full md:w-full ">
                          <div className="w-full px-4 md:px-0 ">
                            <div className="w-full sm:w-full">
                              <span className="text-sm font-bold">
                                {' '}
                                {t('home.payment_type')}
                              </span>
                            </div>
                            <div className="w-full sm:w-full gap-4">
                              <div className="py-4">
                                <label
                                  className={`flex items-center gap-2 border cursor-pointer py-2 px-4 rounded ${
                                    paymentMethod === 'FIB'
                                      ? 'bg-white shadow-md'
                                      : 'bg-slate-100'
                                  }`}
                                >
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="FIB"
                                    // disabled
                                    checked={paymentMethod === 'FIB'}
                                    onChange={() => setPaymentMethod('FIB')}
                                    className="cursor-pointer"
                                  />
                                  <img
                                    src={fibLogo}
                                    alt="FIB"
                                    className="w-6 h-6"
                                  />
                                  <span className="text-slate-600">FIB</span>
                                </label>
                              </div>
                              <div className="w-full sm:w-full flex items-center justify-center">
                                {paymentMethod === 'FIB' && (
                                  <div className="w-full sm:w-full  p-4">
                                    <img
                                      src={fibLogo}
                                      alt="FIB"
                                      className="w-full "
                                    />
                                    <span>{t('home.scan_barcode')}</span>
                                    {/* <Stripe orderId={orderId} price={price} /> */}
                                  </div>
                                )}
                              </div>
                              <div>
                                <label
                                  className={`flex items-center gap-2 border cursor-pointer py-2 px-4 rounded ${
                                    paymentMethod === 'Cash on delivery'
                                      ? 'bg-white shadow-md'
                                      : 'bg-slate-100'
                                  }`}
                                >
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="Cash on delivery"
                                    checked={
                                      paymentMethod === 'Cash on delivery'
                                    }
                                    onChange={() =>
                                      setPaymentMethod('Cash on delivery')
                                    }
                                    className="cursor-pointer"
                                  />
                                  <img
                                    src={codLogo}
                                    alt="COD"
                                    className="w-6 h-6"
                                  />
                                  <span className="text-slate-600">
                                    {t('home.cash_on_delivery')}
                                  </span>
                                </label>
                              </div>

                              {/* <div>
                    {paymentMethod === 'Cash on delivery' && (
                      <div className="w-full sm:w-full  pt-4">
                        <button
                          onClick={() => payment_method_update(paymentMethod)}
                          className="w-full px-10 py-[8px] rounded-sm hover:shadow-green-500/20 hover:shadow-lg bg-[#1b7837] text-white"
                        >
                          <span className="pt-1 text-md">
                            {' '}
                            {t('orderS.submit')}
                          </span>
                        </button>
                      </div>
                    )}
                  </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  {/* End Payment Method */}

                  <button
                    onClick={handlePlaceOrder}
                    disabled={res ? false : true}
                    className={`px-5 py-[9px] rounded-md   ${
                      res ? 'bg-primary hover:bg-[#4e658e]' : 'bg-red-300'
                    }  text-sm text-white uppercase`}
                  >
                    {t('orderS.place_order')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Shipping
